import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  admissionsApi,
  CreateAdmissionRequest,
  SubmitAdmissionDocumentsRequest,
} from '../lib/api/admissions.api';
import { ChangeProgramWithEnrollmentTransitionRequest } from '../lib/api/admissions.api';

export function useAdmissions() {
  const queryClient = useQueryClient();

  const createMutation = useMutation({
    mutationFn: (data: CreateAdmissionRequest) => admissionsApi.create(data),
    onSuccess: () => {
      // Invalidate the admissions list when a new admission is created
      queryClient.invalidateQueries({ queryKey: ['admissions'] });
    },
  });

  const submitDocumentsMutation = useMutation({
    mutationFn: (data: SubmitAdmissionDocumentsRequest) => admissionsApi.submitDocuments(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admissions'] });
    },
  });

  const changeProgramMutation = useMutation({
    mutationFn: (data: ChangeProgramWithEnrollmentTransitionRequest) =>
      admissionsApi.changeProgramWithEnrollmentTransition(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admissions'] });
      queryClient.invalidateQueries({ queryKey: ['enrollments'] });
      queryClient.invalidateQueries({ queryKey: ['tuitionPlans'] });
    },
  });

  return {
    createAdmission: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
    submitDocuments: submitDocumentsMutation.mutateAsync,
    isSubmittingDocs: submitDocumentsMutation.isPending,
    changeProgram: changeProgramMutation.mutateAsync,
    isChangingProgram: changeProgramMutation.isPending,
    changeProgramError: changeProgramMutation.error,
  };
}
